<div
  *ngIf="!loading"
  class="px-3 pt-3 pb-4">
  <p class="font-medium text-2xl">Укажите контактные данные для каждого должника</p>

  <div class="my-3">
    <crm-table
      name="contact-add-welcome"
      [columns]="columns"
      styleClass="sticky-header p-datatable-sm"
      scrollHeight="300px"
      [values]="contacts">
      <ng-template
        #rowTemplate
        let-contact="item">
        <tr *ngIf="toContact(contact) as contact">
          <td class="max-w-10rem">
            {{ contact.client?.name }}
          </td>
          <!-- <td>
            <crm-input-text
              [(value)]="contact.name"
              class="w-full"></crm-input-text>
          </td>
          <td>
            <p-inputMask
              *ngIf="channel === MailingChannelEnum.SMS"
              type="text"
              styleClass="w-full"
              mask="+9 (999) 999-99-99"
              placeholder="+7 (999) 999-99-99"
              [unmask]="true"
              [(ngModel)]="contact.phone"
              name="phone"></p-inputMask>

            <crm-input-text
              *ngIf="channel === MailingChannelEnum.EMAIL"
              [(value)]="contact.email"
              type="email"
              class="w-full"
              name="mail"></crm-input-text>
          </td> -->
        </tr>
      </ng-template>
    </crm-table>
  </div>

  <div
    *ngIf="error?.length"
    class="mb-3">
    <small class="p-error">
      {{ error | join }}
    </small>
  </div>

  <div class="flex justify-content-center">
    <button
      pButton
      type="button"
      label="Далее"
      icon="pi pi-arrow-right"
      iconPos="right"
      class="p-button-success p-button-lg"
      (click)="nextClick()"></button>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-4"></crm-spinner>
